import React from 'react';
import ReactDOM from 'react-dom';

import App from './routes/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import './assets/styles/main.scss';
import './assets/styles/components/typography.scss'



ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// const Index = () => {
//   return (<>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>,
//     {document.getElementById('root')}
//   </>)
// }
// export default Index

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
